// extracted by mini-css-extract-plugin
export default {"Header_container":"Header_Header_container__VJmrM","text":"Header_text__cWjOv"};